export const APP_LEAVING = 'APP_LEAVING';

// Generic action that can potentially kill a lot of boiler plate code
export const LEAF_PROPERTY_CHANGE = 'LeafPropertyChange';
export const THEME_BUTTONS_SET_SPINNER1_COLOR = 'ThemeButtonsSetSpinner1Color';
export const THEME_BUTTONS_SET_SPINNER2_COLOR = 'ThemeButtonsSetSpinner2Color';
export const THEME_BUTTONS_SET_DISABLED_FONT_COLOR = 'ThemeButtonsSetDisabledFontColor';
export const THEME_BUTTONS_SET_DISABLED_BACKGROUND_COLOR = 'ThemeButtonsSetDisabledBackgroundColor';
export const THEME_BUTTONS_SET_LINK_COLOR = 'ThemeButtonsSetLinkColor';
export const THEME_BUTTONS_SET_LINK_TEXT_DECORATION = 'ThemeButtonsSetLinkTextDecoration';
export const THEME_BUTTONS_SET_LINKICON_ICON_COLOR = 'ThemeButtonsSetLinkIconColor';
export const THEME_BUTTONS_SET_LINKICON_FONT_COLOR = 'ThemeButtonsSetLinkIconFontColor';
export const THEME_BUTTONS_SET_LINKICON_TEXT_DECORATION = 'ThemeButtonsSetLinkIconTextDecoration';
export const THEME_BUTTONS_SET_LINKICON_FONT_SIZE = 'THEME_BUTTONS_SET_LINKICON_FONT_SIZE';
export const THEME_BUTTONS_SET_LINKICON_TEXT_TRANSFORM = 'THEME_BUTTONS_SET_LINKICON_TEXT_TRANSFORM';
export const THEME_BUTTONS_SET_LINKICON_FONT_WEIGHT = 'THEME_BUTTONS_SET_LINKICON_FONT_WEIGHT';
export const THEME_BUTTONS_SET_LINKICON_FONT_STYLE = 'THEME_BUTTONS_SET_LINKICON_FONT_STYLE';
export const THEME_BUTTONS_SET_LINKICON_ICON_SIZE = 'THEME_BUTTONS_SET_LINKICON_ICON_SIZE';
export const THEME_BUTTONS_SET_TEXT_TRANSFORM = 'ThemeButtonsSetTextTransform';
export const MANAGE_THEME_ADD_THEME = 'AddTheme';
export const MANAGE_CONFIG_ADD_CONFIG = 'AddConfig';
export const MANAGE_THEME_MODAL_SET_THEME_LEVEL = 'SetThemeLevel';
export const MANAGE_THEME_SET_THEME_STATUS = 'SetThemeStatus';
export const MANAGE_DELETE_ITEM = 'DeleteItem';
export const MANAGE_SET_DEFAULT_THEME = 'ManageSetDefaultTheme';

export const THEME_CARD_SET_THEME_FONT = 'CardSetFont';
export const THEME_CARD_SET_THEME_FONT_SIZE = 'CardSetFontSize';
export const THEME_CARD_SET_THEME_FONT_WEIGHT = 'CardSetFontWeight';
export const THEME_CARD_SET_THEME_FONT_COLOR = 'CardSetFontColor';
export const THEME_CARD_SET_THEME_FONT_STYLE = 'CardSetFontStyle';
export const THEME_CARD_SET_THEME_TEXT_ALIGN = 'CardSetFontAlign';
export const THEME_CARD_SET_THEME_TEXT_DECORATION = 'CardSetDecoration';
export const THEME_CARD_SET_THEME_LINE_HEIGHT = 'CardSetLineHeight';

export const SET_CALENDAR_THEME_VALUE = 'SET_CALENDAR_THEME_VALUE';
export const THEME_CALENDAR_SET_THEME_FONT = 'CalendarSetFont';
export const THEME_CALENDAR_SET_THEME_FONT_SIZE = 'CalendarSetFontSize';
export const THEME_CALENDAR_SET_THEME_FONT_WEIGHT = 'CalendarSetFontWeight';
export const THEME_CALENDAR_SET_THEME_FONT_COLOR = 'CalendarSetFontColor';
export const THEME_CALENDAR_SET_THEME_POPUP_COLOR = 'CalendarSetPopupColor';
export const THEME_CALENDAR_SET_THEME_POPUP_BACKGROUND = 'CalendarSetPopupBackgroundColor';
export const THEME_CALENDAR_SET_THEME_FONT_STYLE = 'CalendarSetFontStyle';
export const THEME_CALENDAR_SET_THEME_TEXT_ALIGN = 'CalendarSetFontAlign';
export const THEME_CALENDAR_SET_THEME_TEXT_DECORATION = 'CalendarSetDecoration';
export const THEME_CALENDAR_SET_THEME_LINE_HEIGHT = 'CalendarSetLineHeight';
export const THEME_CALENDAR_SET_DATE_SELECTED = 'CalendarSetDateSelected';
export const THEME_CALENDAR_SET_DATE_AVAILABLE = 'CalendarSetDateAvailable';
export const THEME_CALENDAR_SET_DATE_UNAVAILABLE = 'CalendarSetDateUnavailable';
export const THEME_CALENDAR_SET_DATE_HOVER = 'THEME_CALENDAR_SET_DATE_HOVER';
export const THEME_CALENDAR_SET_BORDER_COLOR = 'CalendarSetBorderColor';
export const THEME_CALENDAR_SET_BORDER_NO_DATE_COLOR = 'CalendarSetBorderNoDateColor';
export const THEME_CALENDAR_SET_BORDER_STYLE = 'CalendarSetBorderStyle';
export const THEME_CALENDAR_SET_BORDER_WIDTH = 'CalendarSetBorderWidth';
export const THEME_CALENDAR_SET_SPINNER_COLOR1 = 'THEME_CALENDAR_SET_SPINNER_COLOR1';
export const THEME_CALENDAR_SET_SPINNER_COLOR2 = 'THEME_CALENDAR_SET_SPINNER_COLOR2';

export const THEME_GLOBAL_SET_THEME_FONT = 'GlobalSetFont';
export const THEME_GLOBAL_SET_THEME_FONT_SIZE = 'GlobalSetFontSize';
export const THEME_GLOBAL_SET_THEME_FONT_WEIGHT = 'GlobalSetFontWeight';
export const THEME_GLOBAL_SET_THEME_FONT_COLOR = 'GlobalSetFontColor';
export const THEME_GLOBAL_SET_THEME_TEXT_DECORATION = 'GlobalSetTextDecoration';
export const THEME_GLOBAL_SET_THEME_FONT_STYLE = 'GlobalSetFontStyle';
export const THEME_GLOBAL_SET_THEME_BORDER_STYLE = 'GlobalSetBorderStyle';
export const THEME_GLOBAL_SET_THEME_BORDER_WIDTH = 'GlobalSetBorderWidth';
export const THEME_GLOBAL_SET_THEME_LINE_HEIGHT = 'GlobalSetLineHeight';
export const THEME_GLOBAL_SET_THEME_TEXT_ALIGN = 'GlobalSetTextAlign';
export const THEME_GLOBAL_SET_THEME_PRIMARY_BACKGROUND_COLOR = 'GlobalSetBackgroundColor';
export const THEME_GLOBAL_SET_THEME_SECONDARY_BACKGROUND_COLOR = 'GlobalSetSecondaryBackgroundColor';

export const THEME_FILTER_BAR_SET_THEME_FONT = 'FilterBarSetFont';
export const THEME_FILTER_BAR_SET_THEME_FONT_SIZE = 'FilterBarSetFontSize';
export const THEME_FILTER_BAR_SET_THEME_FONT_WEIGHT = 'FilterBarSetFontWeight';
export const THEME_FILTER_BAR_SET_THEME_FONT_COLOR = 'FilterBarSetFontColor';
export const THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_HOVER_COLOR = 'FilterBarSetFontHoverColor';
export const THEME_FILTER_BAR_SET_PRIMARY_TEXT_FONT_STYLE = 'FilterBarSetFontStyle';
export const THEME_FILTER_BAR_SET_PRIMARY_TEXT_DECORATION = 'FilterBarSetTextDecoration';
export const THEME_FILTER_BAR_SET_PRIMARY_TEXT_ALIGN = 'FilterBarSetTextAlign';
export const THEME_FILTER_BAR_SET_PRIMARY_TEXT_LINE_HEIGHT = 'FilterBarSetLineHeight';
export const THEME_FILTER_BAR_SET_GENERAL_BACKGROUND_COLOR = 'FilterBarSetBackgroundColor';
export const THEME_FILTER_BAR_SET_DEFAULT_LINK_COLOR = 'FilterBarSetDefaultLinkColor';
export const THEME_FILTER_BAR_SET_DEFAULT_LINK_HOVER_COLOR = 'FilterBarSetDefaultLinkHoverColor';

export const THEME_HEADER_HAMBURGER_SET_THEME_FONT_SIZE = 'THEME_HEADER_HAMBURGER_SET_THEME_FONT_SIZE';
export const THEME_HEADER_HAMBURGER_SET_THEME_FONT_WEIGHT = 'THEME_HEADER_HAMBURGER_SET_THEME_FONT_WEIGHT';
export const THEME_HEADER_HAMBURGER_SET_THEME_FONT_COLOR = 'THEME_HEADER_HAMBURGER_SET_THEME_FONT_COLOR';
export const THEME_HEADER_HAMBURGER_SET_THEME_BACKGROUND_COLOR =
    'THEME_HEADER_HAMBURGER_SET_THEME_BACKGROUND_COLOR';

export const THEME_FORM_SET_THEME_FONT = 'FormSetFont';
export const THEME_FORM_SET_THEME_FONT_SIZE = 'FormSetFontSize';
export const THEME_FORM_SET_THEME_FONT_WEIGHT = 'FormSetFontWeight';
export const THEME_FORM_SET_THEME_TEXT_DECORATION = 'FormSetTextDecoration';
export const THEME_FORM_SET_THEME_FONT_STYLE = 'FormSetFontStyle';
export const THEME_FORM_SET_THEME_FONT_COLOR = 'FormSetFontColor';
export const THEME_FORM_SET_THEME_BACKGROUND_COLOR = 'THEME_FORM_SET_THEME_BACKGROUND_COLOR';
export const THEME_FORM_SET_THEME_BORDER_COLOR = 'FormSetBorderColor';
export const THEME_FORM_SET_THEME_LINE_HEIGHT = 'THEME_FORM_SET_THEME_LINE_HEIGHT';
export const THEME_FORM_SET_THEME_BORDER_RADIUS = 'THEME_FORM_SET_THEME_BORDER_RADIUS';

export const THEME_COLORS_SET_COLOR = 'ThemeColorsColorChange';
export const THEME_BUTTONS_SET_BACKGROUND_COLOR = 'THEME_BUTTONS_SET_BACKGROUND_COLOR';
export const THEME_BUTTONS_SET_BUTTON_COLOR_NORMAL = 'ThemeSetButtonColorNormal';
export const THEME_BUTTONS_SET_BUTTON_COLOR_HOVER = 'ThemeSetButtonColorHover';
export const THEME_BUTTONS_SET_BUTTON_COLOR_DISABLED = 'ThemeSetButtonColorDisabled';
export const THEME_BUTTONS_SET_FONT_COLOR = 'ThemeSetButtonFontColor';
export const THEME_BUTTONS_SET_TEXT_ALIGN = 'ThemeSetButtonTextAlign';
export const THEME_BUTTONS_SET_FONT = 'ThemeSetButtonFont';
export const THEME_BUTTONS_SET_FONT_SIZE = 'ThemeSetButtonFontSize';
export const THEME_BUTTONS_SET_FONT_STYLE = 'ThemeSetButtonFontStyle';
export const THEME_BUTTONS_SET_FONT_WEIGHT = 'ThemeSetButtonFontWeight';
export const THEME_BUTTONS_SET_BUTTON_STYLE = 'ThemeSetButtonStyle';
export const THEME_BUTTONS_SET_BUTTON_SHAPE = 'ThemeSetButtonShape';
export const THEME_BUTTONS_SET_BORDER_STYLE = 'ThemeSetButtonBorderStyle';
export const THEME_BUTTONS_SET_BORDER_WIDTH = 'ThemeSetButtonBorderWidth';
export const MESSAGE_COLOR = 'MESSAGE_COLOR';
export const BACKGROUND_COLOR = 'BACKGROUND_COLOR';

export const SAVE_STORE_CHANGED = 'StoreChanged';
export const EDIT_STORE_CHANGED = 'EDIT_STORE_CHANGED';
export const SAVE_STORE_SAVED_ON_SERVER = 'StoreSavedOnServer';

export const SAVE_SAVING = 'SaveSaving';
export const SAVE_SUCCESSFUL = 'SaveSuccessful';
export const SAVE_FAILED = 'SaveFailed';

export const SELECT_SAVE_LEVEL = 'SelectSaveLevel';
export const SAVE_SET_SELECTED_CHAIN = 'SelectChainForSave';
export const SAVE_SET_SELECTED_HOTEL = 'SelectHotelForSave';
export const SAVE_SET_SELECTED_BRAND = 'SelectBrandForSave';

export const SAVE_SET_THEME_NAME = 'SelectThemeName';
export const SAVE_SET_THEME_ID = 'SelectThemeId';

export const APP_SAVE_INITIAL_DATA = 'AppSaveInitialData';

export const LEFT_NAV_TOGGLE = 'LEFT_NAV_TOGGLE';
export const LEFT_NAV_SHOW = 'LEFT_NAV_SHOW';
export const LEFT_NAV_HIDE = 'LEFT_NAV_HIDE';

export const LOGIN_SET_HOTELLIST = 'LoginSetHotelList';
export const LOGIN_SET_CHAINLIST = 'LoginSetChainList';
export const LOGIN_SET_DEFAULT_HOTEL = 'LoginSetDefaultHotel';
export const SET_DEFAULT_HOTEL = 'SetDefaultHotel'; // From Header/Modal->selectProperty
export const SET_HOTELLIST = 'SET_HOTELLIST';

export const LOGIN_SET_CHAINID = 'LOGIN_SET_CHAINID';

export const LOGIN_SET_THEME = 'LoginSetTheme';
export const LOGIN_SET_CONFIG = 'LOGIN_SET_CONFIG';
export const SET_IN_CONTEXT_BETA = 'SetInContextBeta';

export const IMAGES_UPLOAD_REQUEST = 'ImagesUploadRequest';
export const IMAGES_UPLOAD_SUCCESS = 'ImagesUploadSuccess';
export const IMAGES_UPLOAD_FAILURE = 'ImagesUploadFailure';

export const IMAGES_ADD_TO_LIBRARY = 'ImagesAddToLibrary';

export const ADD_THEME_LIST = 'AddThemeList';
export const ADD_CONFIG_LIST = 'ADD_CONFIG_LIST';
export const ADD_SALESFORCE_ALLOWED_DOMAIN = 'ADD_SALESFORCE_ALLOWED_DOMAIN';

export const SET_THIRDPARTY_APPS_DATA_IS_CHANGED = 'SET_THIRDPARTY_APPS_DATA_IS_CHANGED';
export const SET_THIRDPARTY_APPS_PARAMETERS = 'SET_THIRDPARTY_APPS_PARAMETERS';

export const SET_BOOLEAN_VALUE_IN_CONFIG = 'SET_BOOLEAN_VALUE_IN_CONFIG';
export const TOGGLE_BOOLEAN_VALUE_IN_CONFIG = 'TOGGLE_BOOLEAN_VALUE_IN_CONFIG';
export const SET_TEXT_VALUE_IN_CONFIG = 'SET_TEXT_VALUE_IN_CONFIG';
export const SET_NUMBER_VALUE_IN_CONFIG = 'SET_NUMBER_VALUE_IN_CONFIG';
export const SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG = 'SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG';
export const SET_LIST_VALUE_IN_CONFIG = 'SET_LIST_VALUE_IN_CONFIG';
export const ADD_CONFIG_ROW = 'ADD_CONFIG_ROW';
export const CHANGE_CONFIG_ROW = 'CHANGE_CONFIG_ROW';
export const EDIT_CONFIG_ROW = 'EDIT_CONFIG_ROW';
export const DELETE_CONFIG_ROW = 'DELETE_CONFIG_ROW';
export const CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE = 'CHANGE_CUSTOM_CONTENT_LANGUAGE_CODE';
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';
export const SET_RETAIL_PRODUCT_CATEGORIES = 'SET_RETAIL_PRODUCT_CATEGORIES';
export const SET_THIRDPARTY_DOMAINS = 'SET_THIRDPARTY_DOMAINS';
export const SET_ARRAY_OR_OBJECT_IN_CONFIG = 'SET_ARRAY_OR_OBJECT_IN_CONFIG';
export const UNSET_VALUE_IN_CONFIG = 'UNSET_VALUE_IN_CONFIG';

export const CHANGE_FIELDS = 'CHANGE_FIELDS';
export const CHANGE_DISPLAYED_FIELDS = 'CHANGE_DISPLAYED_FIELDS';
export const CHANGE_REQUIRED_FIELDS = 'CHANGE_REQUIRED_FIELDS';
export const MAKE_VISIBLE_FILTERS = 'MAKE_VISIBLE_FILTERS';
export const MAKE_INVISIBLE_FILTERS = 'MAKE_INVISIBLE_FILTERS';

export const THEME_MODIFY_KEY = Symbol('THEME_MODIFY_KEY');
export const REFRESH_SELECTED_THEME_FILE = 'REFRESH_SELECTED_THEME_FILE';
export const SET_THEME_FILE_READY_TO_SAVE = 'SET_THEME_FILE_READY_TO_SAVE';
export const SET_THEME_FILE_DATA = 'SET_THEME_FILE_DATA';

export const REFRESH_SELECTED_CONFIG_FILE = 'REFRESH_SELECTED_CONFIG_FILE';
export const SET_CONFIG_FILE_READY_TO_SAVE = 'SET_CONFIG_FILE_READY_TO_SAVE';
export const SET_CONFIG_FILE_DATA = 'SET_CONFIG_FILE_DATA';

// labels actions
export const SET_ENGLISH_LABELS = 'SET_ENGLISH_LABELS';
export const SET_LABELS = 'SET_LABELS';
export const SET_HIGHER_ORDER_LABELS = 'SET_HIGHER_ORDER_LABELS';
export const EDIT_LABELS = 'EDIT_LABELS';
export const CLEAR_LABELS = 'CLEAR_LABELS';
export const LABELS_PROMPT = 'LABELS_PROMPT';
export const LABELS_DISCARD_CHANGES = 'LABELS_DISCARD_CHANGES';
export const SET_LABELS_SAVE_HANDLER = 'SET_LABELS_SAVE_HANDLER';

export const SAVED_LABELS_BATCH = 'SAVED_LABELS_BATCH';
export const SET_HIGHERORDER_LABELS_BATCH = 'SET_HIGHERORDER_LABELS_BATCH';
export const SET_ORIGINALVALUES_LABELS_BATCH = 'SET_ORIGINALVALUES_LABELS_BATCH';
export const SET_CURRENTVALUE_LABELS_BATCH = 'SET_CURRENTVALUE_LABELS_BATCH';
export const UPDATE_CURRENTVALUE_LABELS_BATCH = 'UPDATE_CURRENTVALUE_LABELS_BATCH';
export const DELETE_LABELS_BATCH = 'DELETE_LABELS_BATCH';

export const SET_AVAILABLE_FONTS = 'SET_AVAILABLE_FONTS';
export const CALCULATE_FONT_USAGE = 'CALCULATE_FONT_USAGE';
// file actions

export const SET_ASSETS_LIST = 'SET_ASSETS_LIST';

// frontman chanel actions
export const SHELL_SAVE_REQUEST = 'SHELL_SAVE_REQUEST';
export const SHELL_SAVE_SUCCESS = 'SHELL_SAVE_SUCCESS';
export const SHELL_SAVE_FAILURE = 'SHELL_SAVE_FAILURE';
export const SHELL_SAVE_RESET = 'SHELL_SAVE_RESET';
export const TEMPLATE_SAVE_REQUEST = 'TEMPLATE_SAVE_REQUEST';
export const TEMPLATE_SAVE_SUCCESS = 'TEMPLATE_SAVE_SUCCESS';
export const TEMPLATE_SAVE_FAILURE = 'TEMPLATE_SAVE_FAILURE';
export const TEMPLATE_SAVE_RESET = 'TEMPLATE_SAVE_RESET';
export const GET_FONT_LIST_REQUESTED = 'GET_FONT_LIST_REQUESTED';
export const GET_FONT_LIST_SUCCESS = 'GET_FONT_LIST_SUCCESS';
export const GET_FONT_LIST_FAILED = 'GET_FONT_LIST_FAILED';
export const GET_FONT_LIST_NOT_FOUND = 'GET_FONT_LIST_NOT_FOUND';
export const RETRY_FAILED_SERVICES = 'RETRY_FAILED_SERVICES';

// THIRDPARTY ACTIONS
export const START_THIRDPARTY_CONFIGURATION_FETCH = 'START_THIRDPARTY_CONFIGURATION_FETCH';
export const FINISH_THIRDPARTY_CONFIGURATION_FETCH = 'FINISH_THIRDPARTY_CONFIGURATION_FETCH';
export const ERROR_THIRDPARTY_CONFIGURATION_FETCH = 'ERROR_THIRDPARTY_CONFIGURATION_FETCH';
export const GET_THIRDPARTY_CONFIGURATION = 'GET_THIRDPARTY_CONFIGURATION';
export const GET_ALL_THIRDPARTY_CONFIGURATIONS = 'GET_ALL_THIRDPARTY_CONFIGURATION';
export const SAVE_THIRDPARTY_CONFIGURATION = 'SAVE_THIRDPARTY_CONFIGURATION';
export const SET_LOCAL_CHANGES = 'SET_LOCAL_CHANGES';
export const SET_SOJERN_STATUS_CHANGED = 'SET_SOJERN_STATUS_CHANGED';
export const SET_THN_STATUS_CHANGED = 'SET_THN_STATUS_CHANGED';

export default {
    openModalProperty: 'OPEN_MODAL_PROPERTY',
    closeModalProperty: 'CLOSE_MODAL_PROPERTY',
    openModalTheme: 'OPEN_MODAL_THEME',
    closeModalTheme: 'CLOSE_MODAL_THEME'
};

// INCONTEXT THEME ACTIONS
export const INCONTEXT_THEME_UPDATE_LIGHT = 'INCONTEXT_THEME_UPDATE_LIGHT';
export const INCONTEXT_THEME_UPDATE_FONTS = 'INCONTEXT_THEME_UPDATE_FONTS';
export const RESET_THEME_COLORS = 'RESET_THEME_COLORS';
export const LOGIN_SET_IN_CONTEXT_THEME = 'LOGIN_SET_IN_CONTEXT_THEME';


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js